import React from 'react';
type Props = {
  fill?: string;
};
function Star03({ fill = 'white' }: Props) {
  return (
    <svg
      width='23'
      height='21'
      viewBox='0 0 20 21'
      fill='black'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 0.5L11.9269 5.50985C12.2402 6.32455 12.3969 6.7319 12.6405 7.07454C12.8565 7.37822 13.1218 7.64354 13.4255 7.85948C13.7681 8.10312 14.1755 8.25979 14.9902 8.57314L20 10.5L14.9902 12.4269C14.1755 12.7402 13.7681 12.8969 13.4255 13.1405C13.1218 13.3565 12.8565 13.6218 12.6405 13.9255C12.3969 14.2681 12.2402 14.6755 11.9269 15.4902L10 20.5L8.07314 15.4902C7.75979 14.6755 7.60312 14.2681 7.35948 13.9255C7.14354 13.6218 6.87822 13.3565 6.57454 13.1405C6.2319 12.8969 5.82455 12.7402 5.00985 12.4269L0 10.5L5.00984 8.57314C5.82455 8.25979 6.2319 8.10312 6.57454 7.85948C6.87822 7.64354 7.14354 7.37822 7.35948 7.07454C7.60312 6.7319 7.75979 6.32455 8.07314 5.50985L10 0.5Z'
        fill={fill}
      />
    </svg>
  );
}

export default Star03;
